module.exports = __webpack_public_path__ + "img/home1.1d80ec5f.png";